import { Card, Row, Col, Statistic, Progress, Space, Typography } from "antd"
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons"
import HighchartsReact from "highcharts-react-official"
import Highcharts from "highcharts"
const { Title, Text } = Typography

const kpiChartOptions = {
  chart: {
    type: "area",
    height: 200,
  },
  title: {
    text: null,
  },
  xAxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
  },
  yAxis: {
    title: {
      text: "CAC ($)",
    },
  },
  series: [
    {
      name: "Customer Acquisition Cost",
      data: [120, 115, 108, 105, 98, 95],
      color: "#3b82f6",
      fillOpacity: 0.6,
    },
  ],
  tooltip: {
    formatter: function () {
      return `<b>${this.series.name}</b><br/>${this.x}: $${this.y}`
    },
  },
}

const KpiTracker = () => {
  return (
    <Card style={{ marginBottom: "24px" }}>
          <Title level={4}>Financial KPI Tracker</Title>
          <Text type="secondary">Smart + contextual KPI monitoring</Text>

          <Row gutter={[24, 24]} style={{ margin: "16px 0" }}>
            <Col xs={24} md={8}>
              <Card size="small">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Text strong>Customer Acquisition Cost</Text>
                  <Space>
                    <ArrowDownOutlined style={{ color: "#52c41a" }} />
                    <Text strong style={{ color: "#52c41a" }}>
                      -21%
                    </Text>
                  </Space>
                </div>
                <Statistic value="$95" valueStyle={{ fontSize: "24px", fontWeight: "bold" }} />
                <Text style={{ fontSize: "12px", color: "#52c41a" }}>Best month this year</Text>
                <Progress percent={75} size="small" style={{ marginTop: "8px" }} />
              </Card>
            </Col>

            <Col xs={24} md={8}>
              <Card size="small">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Text strong>Debt to Equity</Text>
                  <Space>
                    <ArrowDownOutlined style={{ color: "#52c41a" }} />
                    <Text strong style={{ color: "#52c41a" }}>
                      -13%
                    </Text>
                  </Space>
                </div>
                <Statistic value="0.48" valueStyle={{ fontSize: "24px", fontWeight: "bold" }} />
                <Text style={{ fontSize: "12px", color: "#52c41a" }}>Healthy improvement</Text>
                <Progress percent={52} size="small" style={{ marginTop: "8px" }} />
              </Card>
            </Col>

            <Col xs={24} md={8}>
              <Card size="small">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Text strong>LTV:CAC Ratio</Text>
                  <Space>
                    <ArrowUpOutlined style={{ color: "#52c41a" }} />
                    <Text strong style={{ color: "#52c41a" }}>
                      +18%
                    </Text>
                  </Space>
                </div>
                <Statistic value="15.3:1" valueStyle={{ fontSize: "24px", fontWeight: "bold" }} />
                <Text style={{ fontSize: "12px", color: "#52c41a" }}>Excellent performance</Text>
                <Progress percent={85} size="small" style={{ marginTop: "8px" }} />
              </Card>
            </Col>
          </Row>

          <HighchartsReact highcharts={Highcharts} options={kpiChartOptions} />
        </Card>
  )
}

export default KpiTracker